import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faHandshake } from '@fortawesome/free-solid-svg-icons';

import HeaderPage from '../components/Header';
import FooterPage from '../components/footer';
import { parceiros } from '../data/parceiros';

function Parcerias() {
  return (
    <>
      <HeaderPage />

      <main>
        <section id="parcerias" className="py-5 bg-light">
          <Container>
            <Row className="text-center mb-5 mt-5">
              <Col>
                <FontAwesomeIcon icon={faHandshake} size="3x" className="text-primary mb-3" />
                <h1 className="text-primary fw-bold mb-3">Parcerias PluginTech</h1>
                <p className="text-muted mx-auto lead" style={{ maxWidth: '720px' }}>
                  Conheça empresas parceiras que recomendamos com confiança. Ao acessar pelos links
                  abaixo, você apoia a PluginTech!
                </p>
              </Col>
            </Row>

            <Row className="g-4">
              {parceiros.map((parceiro) => (
                <Col key={parceiro.id} lg={4} md={6}>
                  <Card className="h-100 shadow-sm border-0 partner-card">
                    <div className="partner-card-logo">
                      <img src={parceiro.image} alt={parceiro.name} />
                    </div>
                    <Card.Body className="d-flex flex-column p-4">
                      <Card.Title className="h5 mb-3">{parceiro.name}</Card.Title>
                      <Card.Text className="text-muted flex-grow-1">{parceiro.description}</Card.Text>
                      <Button
                        href={parceiro.link}
                        target="_blank"
                        rel="noopener noreferrer sponsored"
                        className="btn btn-primary mt-3 align-self-start"
                      >
                        Visitar parceiro
                        <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-2" size="sm" />
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </main>

      <FooterPage />
    </>
  );
}

export default Parcerias;
